import { render } from "./PurchaseReceiveBoard.vue?vue&type=template&id=242d669b&scoped=true"
import script from "./PurchaseReceiveBoard.vue?vue&type=script&lang=js"
export * from "./PurchaseReceiveBoard.vue?vue&type=script&lang=js"

import "./PurchaseReceiveBoard.vue?vue&type=style&index=0&id=242d669b&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-242d669b"]])

export default __exports__